<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="m-3">
      <h3>Add New Management</h3>
      <AddElement category_id="8"></AddElement>
    </div>
  </div>
</template>

<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {

  name: "AddNewManagement",
  components: {
    AddElement,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Management',
          to: '/managements/all'
        }, {
          text: 'Add Management',
          href: '#'
        }
      ],
    };
  },
};
</script>